import { Box, ColorOptions, convertHexToRGBA, Icon, IconButton, ModBox, Spacer, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { SvgImage } from '../../comps/SvgImage'
import { Colors, DOWNLOAD_FAILED, FILE_DOWNLOADED } from '../../util/util'
import { Platform } from 'react-native'

const props = (status: number) => {
  if (status === FILE_DOWNLOADED) {
    return {
      imgName: 'downloadFile',
      title: 'Transaction Statement Downloaded',
      subTitle: Platform.OS === 'ios' ? 'File is saved on your device -> files folder -> Browse -> On My iPhone -> JioPay Business' : 'File is saved on your device.',
      color: 'BLACK',
      borderWidth: 4,
      borderColor: convertHexToRGBA('#000000', 12),
      btnTitle: 'View File',
    }
  }
  if (status === DOWNLOAD_FAILED) {
    return {
      imgName: 'errorbadge',
      title: 'Transaction Statement Failed',
      color: '#ffffff',
      borderWidth: 12,
      borderColor: 'RED',
      btnTitle: 'Generate Again',
    }
  }
  return {
    imgName: 'errorbadge',
    title: 'Transaction Statement Failed',
    color: '#ffffff',
    borderWidth: 12,
    borderColor: 'RED',
    btnTitle: 'Generate Again',
  }
}
export const DownloadFileModal = ({ status, onShare, onPress, close }) => {
  const { imgName, title, subTitle, color, borderWidth, borderColor, btnTitle } = props(status)
  return (
    <Box pt={36} ph={24} pb={24}>
      <Box flexDirection={'row'} align={'center'} justify={'space-between'}>
        <Box
          h={48}
          w={48}
          bg={color as ColorOptions}
          align={'center'}
          justify={'center'}
          borderRadius={24}
          borderWidth={borderWidth}
          borderColor={borderColor as ColorOptions}>
          <SvgImage imageName={imgName} width={24} height={24} color={'#ffffff'} />
          <ModBox show={status === 1} position={'absolute'} right={-8} bottom={-2} bg={'WHITE'} borderRadius={10}>
            <Icon id={'SUCCESSFUL_FILLED'} size={20} color={'GREEN' as ColorOptions} />
          </ModBox>
        </Box>
        <IconButton onPress={close} testID="close" id={'CLOSE'} size={24} color={'BLACK'} />
      </Box>
      <Spacer direction="vertical" size={16} />
      <Box maxWidth={'75%'}>
        <Text
          title={title}
          fontFamily={'JioType-Black'}
          fontSize={24}
          lineHeight={32}
          letterSpacing={-0.12}
          color={Colors.BLACK_14 as ColorOptions}
        />
      </Box>
      <Spacer direction="vertical" size={isEmpty(subTitle) ? 0 : 16} />
      <Text
        title={subTitle}
        fontFamily={'JioType-Medium'}
        fontSize={14}
        lineHeight={18}
        letterSpacing={-0.07}
        color={convertHexToRGBA('#000000', 65) as ColorOptions}
        hide={isEmpty(subTitle)}
      />
      <Spacer direction="vertical" size={40} />
      <Box flexDirection={'row'} align={'center'} justify={'space-between'}>
        <ModBox
          show={status === 1}
          f={1}
          onPress={onShare}
          testID="share-file"
          borderColor={'PRIMARY'}
          bg={'WHITE'}
          borderWidth={1}
          borderRadius={32}
          align={'center'}
          h={48}
          underlayColor={convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions}
          justify={'center'}>
          <Text
            title={'Share'}
            fontFamily={'JioType-Bold'}
            fontSize={16}
            lineHeight={18}
            letterSpacing={-0.08}
            color={'PRIMARY'}
          />
        </ModBox>
        <ModBox show={status === 1}>
          <Spacer size={16} direction="horizontal" />
        </ModBox>
        <ModBox
          f={1}
          onPress={onPress}
          testID={'btnTitle-' + btnTitle}
          bg={'PRIMARY'}
          borderRadius={32}
          align={'center'}
          justify={'center'}
          h={48}
          underlayColor={convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions}>
          <Text
            title={btnTitle}
            fontFamily={'JioType-Bold'}
            fontSize={16}
            lineHeight={18}
            letterSpacing={-0.08}
            color={'WHITE'}
          />
        </ModBox>
      </Box>
    </Box>
  )
}
